import script from "./PrincipalPageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrincipalPageView.vue?vue&type=script&setup=true&lang=ts"

import "./PrincipalPageView.vue?vue&type=style&index=0&id=5afdab39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afdab39"]])

export default __exports__